import { client as contentStudioClient } from '@inference.engine/content-studio-api-client/web';
import { ENV } from '@/lib/config/env';
import { configureApiClient } from './configure-client';

type ContentStudioHttp = typeof contentStudioClient;

let instance: ContentStudioHttp | undefined;

function initClient(): ContentStudioHttp {
  if (!ENV.CONTENT_STUDIO_API_BASE_URL) {
    throw new Error('CONTENT_STUDIO_API_BASE_URL environment variable is not set');
  }

  contentStudioClient.setConfig({
    throwOnError: true,
  });

  return configureApiClient(contentStudioClient, ENV.CONTENT_STUDIO_API_BASE_URL);
}

export const contentStudioHttp = new Proxy({} as ContentStudioHttp, {
  get(_target, prop) {
    instance ??= initClient();
    return Reflect.get(instance, prop, instance);
  },
});
